var map = {
	".": 82624,
	"./": 82624,
	"./copy": 11720,
	"./copy.data": 6779,
	"./copy.data.ts": 6779,
	"./copy.ts": 11720,
	"./copy.types": 16520,
	"./copy.types.ts": 16520,
	"./global": 90427,
	"./global.ts": 90427,
	"./index": 82624,
	"./index.ts": 82624,
	"./opportunities": 11315,
	"./opportunities.ts": 11315,
	"./translations/en/footer": 89191,
	"./translations/en/footer.json": 89191,
	"./translations/en/global": 97342,
	"./translations/en/global.json": 97342,
	"./translations/en/globalTemp": 2240,
	"./translations/en/globalTemp.json": 2240,
	"./translations/en/head": 97420,
	"./translations/en/head.json": 97420,
	"./translations/en/navbar": 23217,
	"./translations/en/navbar.json": 23217,
	"./translations/pl/footer": 34497,
	"./translations/pl/footer.json": 34497,
	"./translations/pl/global": 2158,
	"./translations/pl/global.json": 2158,
	"./translations/pl/head": 62332,
	"./translations/pl/head.json": 62332,
	"./translations/pl/navbar": 48536,
	"./translations/pl/navbar.json": 48536,
	"store": 82624,
	"store/": 82624,
	"store/copy": 11720,
	"store/copy.data": 6779,
	"store/copy.data.ts": 6779,
	"store/copy.ts": 11720,
	"store/copy.types": 16520,
	"store/copy.types.ts": 16520,
	"store/global": 90427,
	"store/global.ts": 90427,
	"store/index": 82624,
	"store/index.ts": 82624,
	"store/opportunities": 11315,
	"store/opportunities.ts": 11315,
	"store/translations/en/footer": 89191,
	"store/translations/en/footer.json": 89191,
	"store/translations/en/global": 97342,
	"store/translations/en/global.json": 97342,
	"store/translations/en/globalTemp": 2240,
	"store/translations/en/globalTemp.json": 2240,
	"store/translations/en/head": 97420,
	"store/translations/en/head.json": 97420,
	"store/translations/en/navbar": 23217,
	"store/translations/en/navbar.json": 23217,
	"store/translations/pl/footer": 34497,
	"store/translations/pl/footer.json": 34497,
	"store/translations/pl/global": 2158,
	"store/translations/pl/global.json": 2158,
	"store/translations/pl/head": 62332,
	"store/translations/pl/head.json": 62332,
	"store/translations/pl/navbar": 48536,
	"store/translations/pl/navbar.json": 48536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3770;